// ─── Treatment step types ─────────────────────────────────────────────────────
// The step "type" values Petrix accepts on the schedule topic. Keep in sync
// with poster-worker-db.py: SAND_STEP_TYPES reads 'Proppant' / 'Sand Ramp' and
// DROP_STEP_TYPES writes 'Diverter' / 'Proppant' from this same vocabulary.
//
// Consumers: TreatmentDataGraph, TreatmentModal (step type dropdown).

export const TREATMENT_TYPE_OPTIONS = [
  'Acid',
  'Acid Spearhead',
  'Breakdown',
  'Displacement',
  'Diverter',
  'FET',
  'Flush',
  'Load',
  'Overflush',
  'Pad',
  'Pre-Flush',
  'Pre-Pad',
  'Proppant',
  'Pump-in',
  'Pumpdown',
  'Rate Drop',
  'Rate Drop-Proppant',
  'Rate Drop-Sand Ramp',
  'Sand Ramp',
  'Shutdown',
  'Spacer',
  'Sweep'
];

// Types that carry proppant — the ones a concentration and sand type apply to.
export const SAND_STEP_TYPES = ['Proppant', 'Sand Ramp'];
